export interface CommunityReply {
  id: string;
  author: string;
  role: string;
  time: string;
  content: string;
  likes: number;
  essence: boolean;
  replies?: { author: string; content: string; likes: number }[];
}

export interface CommunityPost {
  id: string;
  title: string;
  summary: string;
  category: string;
  categorySlug: string;
  author: string;
  authorTitle: string;
  time: string;
  cover: string;
  coverAlt: string;
  tags: string[];
  heat: number;
  likes: number;
  favorites: number;
  replyCount: number;
  pinned: boolean;
  essence: boolean;
  content: string[];
  replies: CommunityReply[];
}

export const communityPosts: CommunityPost[] = [
  {
    id: "1024",
    title: "楼下超市阿姨把收款提示音换成了自己录的，一排队就有人笑到扶墙",
    summary:
      "本来只想买瓶水，结果为了听那一声「到账成功」，硬是在收银台前排了三分钟。阿姨说这是她的独家服务，不额外收费。",
    category: "今日瓜田",
    categorySlug: "daily",
    author: "瓜田里的老李",
    authorTitle: "围观区常驻嘉宾",
    time: "今天 09:12",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cozy%20neighborhood%20convenience%20store%20checkout%20counter%20with%20small%20fruit%20baskets%20and%20string%20lights%2C%20soft%20morning%20sunlight%20through%20window%2C%20editorial%20documentary%20photography%2C%20warm%20amber%20tones%2C%20clean%20minimal%20composition&width=1200&height=800&seq=gossip-daily-market-01&orientation=landscape",
    coverAlt: "温暖的社区便利店收银台场景",
    tags: ["今日热帖", "生活趣闻", "神回复"],
    heat: 98650,
    likes: 4821,
    favorites: 1203,
    replyCount: 386,
    pinned: true,
    essence: true,
    content: [
      "事情是这样的。今天早上出门忘带水，就拐进楼下那家开了快十年的小超市。结账的时候前面排着四个人，我本来有点赶时间，结果那声提示音一响，整队人集体愣了两秒。",
      "不是那种冷冰冰的机器声，是阿姨本人拿手机录的：「到账成功，祝你不内耗，也祝你不加班。」尾音还带点上扬，像菜市场里报菜价的调子。",
      "排在我前面的大哥直接笑出声，说这一句值回票价。阿姨一边扫码一边特别淡定：『录了十来条，每天换着放，谁要是听烦了我再换。』",
      "我买完水已经走出去了，又折回来拍了一张收银台。不是为了发帖，是觉得这种小惊喜，比很多精心策划的活动都让人记住。",
      "后来我站在门口数了一下，五分钟里有三拨人为了听下一句，故意多买了一袋橘子。阿姨的生意，可能就是这么被一句提示音做起来的。",
    ],
    replies: [
      {
        id: "r-1024-1",
        author: "打工人小周",
        role: "金句制造机",
        time: "今天 09:20",
        content:
          "建议阿姨申报非物质文化遗产，名字我都想好了：《社区收银台祝福语·活态传承》。",
        likes: 3620,
        essence: true,
        replies: [
          { author: "瓜田里的老李", content: "这条我已经抄在备忘录里了，下次去必念给阿姨听。", likes: 512 },
          { author: "路人乙", content: "非遗评审：同意，且建议全国推广。", likes: 288 },
        ],
      },
      {
        id: "r-1024-2",
        author: "橘子刺客",
        role: "围观群众",
        time: "今天 09:31",
        content:
          "终于知道为什么我上次买一袋橘子花了四十二块，原来我不是在买橘子，我是在为情绪价值付费。",
        likes: 2418,
        essence: true,
      },
      {
        id: "r-1024-3",
        author: "夜班便利店观察员",
        role: "加精贡献者",
        time: "今天 09:47",
        content:
          "补充一个：阿姨柜台底下有个小本子，记着谁常买什么。我上周去买咖啡，她说『还是不加糖吧』，我当场社死又当场感动。",
        likes: 1936,
        essence: false,
      },
      {
        id: "r-1024-4",
        author: "不熬夜第一名",
        role: "围观群众",
        time: "今天 10:02",
        content: "阿姨这波属于用提示音做私域运营，建议大厂运营部集体来抄作业。",
        likes: 1420,
        essence: false,
      },
    ],
  },
  {
    id: "1023",
    title: "同事把我工位上的绿植养成他家的了，理由是「替你积德」",
    summary:
      "出差两周回来，我的小绿萝不仅长了半米，盆也换了、肥也施了，同事还认真地说这是替我在公司积德。",
    category: "职场观察",
    categorySlug: "workplace",
    author: "工位守夜人",
    authorTitle: "职场观察员",
    time: "今天 08:40",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20modern%20office%20desk%20with%20lush%20green%20pothos%20plant%20in%20a%20terracotta%20pot%2C%20notebooks%20and%20coffee%20cup%2C%20soft%20window%20light%2C%20editorial%20lifestyle%20photography%2C%20warm%20neutral%20tones%2C%20clean%20uncluttered%20composition&width=1200&height=800&seq=gossip-office-plant-02&orientation=landscape",
    coverAlt: "办公室工位上的绿萝与办公用品",
    tags: ["职场", "趣闻", "热评"],
    heat: 87230,
    likes: 3960,
    favorites: 987,
    replyCount: 271,
    pinned: false,
    essence: true,
    content: [
      "出差前我在工位留了一盆小绿萝，临走时叮嘱隔壁工位的同事帮我浇点水，纯粹是怕它渴死。",
      "两周后回来，那盆绿萝已经爬满了我的显示器支架，盆从塑料的换成了陶的，土松过，边上还插着一张卡片：「已施肥，勿谢。」",
      "我问他是不是顺便把它当自己的养了，他特别认真地回我：『我这是替你积德，你工位风水太差。』然后补充说，浇水的时候会跟它说话，据说这样长得快。",
      "我本来想反驳，结果那天下午开例会，我的方案居然一次过。行吧，科学解释不了的部分，先记在绿萝账号上。",
      "现在我们部门流行一句话：工位可以乱，绿植不能亏。据说隔壁组已经开始排队请这位同事去「调理风水」了。",
    ],
    replies: [
      {
        id: "r-1023-1",
        author: "PPT搬运工",
        role: "金句制造机",
        time: "今天 08:52",
        content: "这不是养绿植，这是在给你的职业生涯做长线投资，建议给同事加个联席 CEO 头衔。",
        likes: 2104,
        essence: true,
      },
      {
        id: "r-1023-2",
        author: "楼下咖啡师",
        role: "围观群众",
        time: "今天 09:05",
        content:
          "重点是他还跟植物说话。我合理怀疑，我们公司最会做心理疏导的其实是他。",
        likes: 1288,
        essence: false,
      },
      {
        id: "r-1023-3",
        author: "实习生阿澈",
        role: "加精贡献者",
        time: "今天 09:26",
        content:
          "求同事工位号，我的多肉快不行了，我先替它预约一个号，排到明年也行。",
        likes: 964,
        essence: false,
        replies: [
          { author: "工位守夜人", content: "排号已经到三十七位了，你先加个微信。", likes: 341 },
        ],
      },
    ],
  },
  {
    id: "1022",
    title: "外卖备注「不要香菜」被老板回了一张手写便签，我当场笑出声",
    summary:
      "点了一份牛肉面，备注写得很客气。结果外卖到手，餐盒上贴着一张便签：「已郑重对待，请放心。」",
    category: "今日瓜田",
    categorySlug: "daily",
    author: "面条收割机",
    authorTitle: "围观区常驻嘉宾",
    time: "昨天 21:35",
    cover:
      "https://readdy.ai/api/search-image?query=Steaming%20bowl%20of%20beef%20noodles%20in%20takeout%20box%20with%20a%20small%20handwritten%20note%20beside%20it%2C%20warm%20home%20table%20setting%2C%20soft%20evening%20light%2C%20appetizing%20food%20photography%2C%20warm%20amber%20tones%2C%20clean%20simple%20background&width=1200&height=800&seq=gossip-noodle-note-03&orientation=landscape",
    coverAlt: "牛肉面外卖与手写便签",
    tags: ["外卖", "生活趣闻"],
    heat: 76410,
    likes: 3210,
    favorites: 742,
    replyCount: 198,
    pinned: false,
    essence: false,
    content: [
      "我点外卖有个习惯，备注一定写得客客气气，因为总觉得对面是个人，不是按钮。这次我只写了一句：「不好意思，不要香菜，谢谢您。」",
      "餐盒拿到手，上面贴着一张手写便签，字有点歪：「已郑重对待，请放心。香菜已列入本店黑名单，今日特供无香菜专区。」",
      "我盯着那张便签笑了半天，甚至拍照发给了我妈，我妈回了一句：『那你下次记得点他们家别的。』",
      "后来我翻了翻评价区，好多人都晒过这家老板的便签，有人说收到过「祝你胃口好」，有人说收到过一张画着小太阳的。",
      "我算是明白了，有些小店能活下来，靠的不只是味道，还有那种被人认真对待的感觉。当天我把汤都喝完了，一点没剩。",
    ],
    replies: [
      {
        id: "r-1022-1",
        author: "香菜绝缘体",
        role: "围观群众",
        time: "昨天 21:48",
        content: "老板这情商，建议直接开个备注代写业务，我先下单一个月。",
        likes: 1560,
        essence: true,
      },
      {
        id: "r-1022-2",
        author: "深夜放毒选手",
        role: "金句制造机",
        time: "昨天 22:03",
        content:
          "看别人收便签我没哭，看到你妈的那句回复我哭了，原来全天下的妈妈都只会关心你下次点哪家。",
        likes: 1342,
        essence: true,
      },
      {
        id: "r-1022-3",
        author: "吃面不喝汤",
        role: "围观群众",
        time: "昨天 22:20",
        content: "香菜：我招谁惹谁了。老板：你负责被拉黑，我负责被夸。",
        likes: 876,
        essence: false,
      },
    ],
  },
  {
    id: "1021",
    title: "把闹钟铃声换成室友的呼噜声之后，我竟然连续一周没赖床",
    summary:
      "本来是报复性操作，结果意外解锁了高效起床新姿势。室友表示：这波我成工具人了。",
    category: "网络热梗",
    categorySlug: "memes",
    author: "早八幸存者",
    authorTitle: "现象观察员",
    time: "昨天 19:10",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20early%20morning%20bedroom%20with%20phone%20on%20nightstand%20and%20soft%20linen%20bedding%2C%20first%20dawn%20light%20through%20sheer%20curtains%2C%20calm%20minimal%20lifestyle%20photography%2C%20warm%20muted%20tones%2C%20simple%20composition&width=1200&height=800&seq=gossip-alarm-bedroom-04&orientation=landscape",
    coverAlt: "清晨卧室床头柜上的手机",
    tags: ["热梗", "生活实验", "神回复"],
    heat: 69820,
    likes: 2874,
    favorites: 651,
    replyCount: 166,
    pinned: false,
    essence: true,
    content: [
      "我室友的呼噜声有个特点，均匀、低沉、还带一点节奏感，像有人在你耳边开了一台老式发动机。我忍了半学期，直到某天灵机一动，把它录了三十秒，设成了我的闹钟。",
      "第一天早上，铃声一响，我从床上弹起来的动作比军训还标准。因为那声音离我太近了，大脑第一反应是『他是不是趴在我枕头边』。",
      "一周之后我发现，赖床彻底治好了。不是被吵醒的烦躁，而是一种生理性的警觉，听到就想跑。",
      "我把这个发现发到群里，室友沉默了很久，然后回了一句：『所以我这是在做公益？』为了补偿他，我请他吃了三顿早饭。",
      "现在我把它分享出来，不是建议你也这么干，只是想说明一个道理：有些问题不用解决，换个角度它自己就变成了资源。",
    ],
    replies: [
      {
        id: "r-1021-1",
        author: "生物钟已报废",
        role: "金句制造机",
        time: "昨天 19:24",
        content: "这不是闹钟，这是把室友的睡眠变成你的生产力，属于家庭内部的资源共享。",
        likes: 1189,
        essence: true,
      },
      {
        id: "r-1021-2",
        author: "宿舍纪律委员",
        role: "围观群众",
        time: "昨天 19:40",
        content: "建议申请专利，名字就叫《基于室友呼噜的强制起床系统》，听起来就很贵。",
        likes: 742,
        essence: false,
      },
      {
        id: "r-1021-3",
        author: "睡到自然醒协会",
        role: "围观群众",
        time: "昨天 20:01",
        content: "室友：我什么都没做，就火了，还是负面的那种。",
        likes: 590,
        essence: false,
      },
    ],
  },
  {
    id: "1020",
    title: "小区快递柜旁多了个「免费盲盒」架子，结果比抽奖还刺激",
    summary:
      "邻居们把用不上的小物件放上去，谁需要谁拿走。三天时间，那个架子成了整个小区最热闹的地方。",
    category: "邻里生活",
    categorySlug: "neighbor",
    author: "楼道观察员",
    authorTitle: "社区记录者",
    time: "前天 17:22",
    cover:
      "https://readdy.ai/api/search-image?query=Small%20friendly%20community%20exchange%20shelf%20with%20books%20and%20small%20everyday%20objects%20next%20to%20parcel%20lockers%2C%20warm%20afternoon%20sunlight%2C%20documentary%20street%20photography%2C%20warm%20earthy%20tones%2C%20inviting%20composition&width=1200&height=800&seq=gossip-community-shelf-05&orientation=landscape",
    coverAlt: "小区快递柜旁的物品交换架",
    tags: ["邻里", "温暖日常"],
    heat: 61230,
    likes: 2312,
    favorites: 588,
    replyCount: 143,
    pinned: false,
    essence: false,
    content: [
      "我们小区的快递柜旁边，原来只是个放闲置纸箱的角落。上周不知道谁搬来一个三层小架子，贴了张纸：『用得上就拿走，用不上就留下。』",
      "第一天上面只有两本旧杂志和一个多余的手机支架。第二天变成了马克杯、跳绳、没拆封的收纳盒。第三天，出现了一个能用的加湿器和一袋没到期的猫粮。",
      "最热闹的是傍晚。放东西的人会站一会儿，看有没有人拿；拿东西的人也不好意思空手走，隔天就补上别的。",
      "有位阿姨放了一盆自己种的小葱，还附了张纸：「剪着吃，会再长。」结果第二天就有人在下面补了一瓶营养液。",
      "我拍了张照片发在业主群，有人评论说：这个架子比我们家的冰箱还懂人情世故。我承认，我笑完之后，默默把家里闲置的台灯搬了下去。",
    ],
    replies: [
      {
        id: "r-1020-1",
        author: "楼上种葱的阿姨",
        role: "围務群众",
        time: "前天 17:40",
        content: "那瓶营养液是我放的，我不知道是谁补的，但我想说，谢谢那位懂小葱的人。",
        likes: 1420,
        essence: true,
      },
      {
        id: "r-1020-2",
        author: "随手补货的人",
        role: "围观群众",
        time: "前天 18:05",
        content: "小葱长好了记得第一茬给我，我拿新的营养液换，这个交易很划算。",
        likes: 688,
        essence: false,
      },
      {
        id: "r-1020-3",
        author: "社恐但热心",
        role: "金句制造机",
        time: "前天 18:33",
        content: "这种架子的精髓是：不用打招呼，也能表达善意。社恐狂喜。",
        likes: 1104,
        essence: true,
      },
    ],
  },
  {
    id: "1019",
    title: "社团招新时学长说「来了就是家人」，我信了，然后真被拉进了家庭群",
    summary:
      "原以为是句客套话，直到我在群里收到了生日祝福、感冒问候和一箱寄到宿舍的橘子，才发现这家人是认真的。",
    category: "校园故事",
    categorySlug: "campus",
    author: "大一新生小满",
    authorTitle: "校园分享者",
    time: "前天 14:08",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20university%20campus%20club%20signup%20booth%20with%20colorful%20posters%20and%20a%20small%20basket%20of%20oranges%2C%20autumn%20afternoon%20light%2C%20candid%20student%20life%20photography%2C%20warm%20golden%20tones%2C%20lively%20yet%20clean%20composition&width=1200&height=800&seq=gossip-campus-club-06&orientation=landscape",
    coverAlt: "大学校园社团招新摊位",
    tags: ["校园", "温暖日常", "新人必看"],
    heat: 54880,
    likes: 1988,
    favorites: 502,
    replyCount: 121,
    pinned: false,
    essence: false,
    content: [
      "九月社团招新，我在人挤人的操场上一眼相中了那个标语写着「来了就是家人」的摊位。学长学姐笑得特别热情，我就报了名。",
      "当天晚上，我收到了三条好友申请和一个群邀请，群名很长，叫「2026 届家人联络总群（禁止退群）」。我以为又是那种发通知就沉底的群。",
      "结果第二天早上，群里准时出现了「今日天气提醒」，配图是学长自己拍的食堂窗口排队长度。第三天生日的同学，被十几个人轮流刷屏祝福。",
      "上周我有点感冒，在群里随口提了一句，晚上就收到了一箱橘子，附纸条：「多吃点，维 C 管够。」寄件人是我们社长。",
      "我承认，一开始我以为「家人」只是句好听的客套。现在我发现，有些话说出口的人，是真的会去做的。这一届，我打算好好待下去。",
    ],
    replies: [
      {
        id: "r-1019-1",
        author: "毕业三年的老学长",
        role: "围观群众",
        time: "前天 14:26",
        content: "群还在吗？我想回去看看，当年我就是那个负责拍食堂排队的人。",
        likes: 1064,
        essence: true,
      },
      {
        id: "r-1019-2",
        author: "社恐新生",
        role: "围观群众",
        time: "前天 15:02",
        content: "看哭了，我们社团的群名是「通知群（勿回复）」，对比太惨烈了。",
        likes: 812,
        essence: false,
      },
      {
        id: "r-1019-3",
        author: "橘子管理员",
        role: "金句制造机",
        time: "前天 15:30",
        content: "「禁止退群」这四个字，比任何招新文案都有说服力。",
        likes: 966,
        essence: true,
      },
    ],
  },
  {
    id: "1018",
    title: "把家里的旧台历改成「每日一句」，全家抢着翻第二天",
    summary:
      "一次断舍离的意外产物。写了三十张便签之后，全家人每天早上第一件事，就是去看今天写的是什么。",
    category: "生活灵感",
    categorySlug: "life",
    author: "阳台手作组",
    authorTitle: "生活灵感分享者",
    time: "3 天前",
    cover:
      "https://readdy.ai/api/search-image?query=Wooden%20desk%20with%20a%20refurbished%20desk%20calendar%20covered%20in%20handwritten%20sticky%20notes%2C%20small%20potted%20plant%20and%20warm%20lamp%2C%20cozy%20evening%20workspace%2C%20editorial%20still%20life%20photography%2C%20warm%20amber%20tones%2C%20tidy%20composition&width=1200&height=800&seq=gossip-desk-calendar-07&orientation=landscape",
    coverAlt: "贴着便签的木质台历与桌面",
    tags: ["生活灵感", "手作", "居家"],
    heat: 47650,
    likes: 1642,
    favorites: 733,
    replyCount: 98,
    pinned: false,
    essence: false,
    content: [
      "大扫除的时候翻出一本去年的台历，本来是要扔的，我盯着那些空白的格子看了一会儿，突然觉得扔了可惜。",
      "我把每一页撕下来，在背面写上不同的内容：有的是提醒，比如「今天记得给花换水」；有的是一句玩笑，比如「希望今天的外卖准时」；还有的是写给家人的，比如「谢谢你昨天帮我拿快递」。",
      "三十张便签贴上去之后，台历一下子变得很厚。第二天早上，我爸第一个去翻，翻完在餐桌前念了出来，全家人笑了半天。",
      "现在这成了我们家的固定节目。谁先起床谁负责翻页，翻到好笑的会拍照发群。有次我写了一句「今天全家胃口好」，我妈真的一整天都很开心。",
      "旧台历没扔，反而变成了家里最忙的一件东西。有时候我在想，所谓的生活仪式感，可能就是把「随手」变成「特意」。",
    ],
    replies: [
      {
        id: "r-1018-1",
        author: "断舍离失败案例",
        role: "围观群众",
        time: "3 天前",
        content: "本来想说扔了多省事，看完默默去翻我家那本 2023 的台历了。",
        likes: 688,
        essence: false,
      },
      {
        id: "r-1018-2",
        author: "全家最会整活",
        role: "金句制造机",
        time: "3 天前",
        content: "建议出一本《家庭每日一句合集》，我家先预定三本，一本给我爸，一本贴冰箱。",
        likes: 742,
        essence: true,
      },
    ],
  },
  {
    id: "1017",
    title: "健身房的教练每天在群里发「今天吃了吗」，但从不推销",
    summary:
      "半年了，他没让我办过一张卡，倒是记得我每一次感冒和多吃的半碗饭。这种教练现在真的不多了。",
    category: "职场观察",
    categorySlug: "workplace",
    author: "自律失败者",
    authorTitle: "现象观察员",
    time: "3 天前",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20clean%20neighborhood%20gym%20interior%20with%20kettlebells%20and%20wooden%20floor%2C%20morning%20light%20through%20large%20windows%2C%20calm%20fitness%20lifestyle%20photography%2C%20warm%20neutral%20tones%2C%20uncluttered%20composition&width=1200&height=800&seq=gossip-gym-coach-08&orientation=landscape",
    coverAlt: "明亮整洁的社区健身房",
    tags: ["生活实验", "职场", "热评"],
    heat: 42110,
    likes: 1533,
    favorites: 418,
    replyCount: 87,
    pinned: false,
    essence: true,
    content: [
      "我办健身卡那年冬天只去过四次，第五次是去退卡的，结果没退成，因为教练说了一句话：『你先别退，我给你留个位置，什么时候来都行。』",
      "后来他建了个小群，群里一共七个人，每天早上八点他会发一句「今天吃了吗」，配一张健身房的空镜。不发广告，不催课，也不问我们为什么不来。",
      "有一次我连着三天没去，他没催，只是私聊问我最近是不是忙。我说有点感冒，他说那先休息，别硬练。那一刻我反而有点惭愧。",
      "半年下来，我去健身房的次数还是不多，但群里那七个人，几乎都留了下来。有次我问他为什么不推销，他说：『推销能来一次，习惯才能来一百次。』",
      "现在我不太焦虑自己的健身打卡了。慢慢来，好像也算一种进步。",
    ],
    replies: [
      {
        id: "r-1017-1",
        author: "办了三年卡的幽灵会员",
        role: "围观群众",
        time: "3 天前",
        content: "「推销能来一次，习惯才能来一百次」，这句我要拿去跟我的私教复述三遍。",
        likes: 906,
        essence: true,
      },
      {
        id: "r-1017-2",
        author: "周末才运动",
        role: "围观群众",
        time: "3 天前",
        content: "建议这种教练按非遗保护起来，太稀缺了。",
        likes: 512,
        essence: false,
      },
    ],
  },
  {
    id: "1016",
    title: "把废弃的公交站牌做成书架，社区图书角一夜之间被搬空了一半",
    summary:
      "居委会只是想让旧东西别浪费，没想到第二天架子上多出了三十多本书，还附了几张读书笔记便签。",
    category: "邻里生活",
    categorySlug: "neighbor",
    author: "社区图书管理员",
    authorTitle: "社区记录者",
    time: "4 天前",
    cover:
      "https://readdy.ai/api/search-image?query=Repurposed%20community%20bookshelf%20made%20from%20wooden%20frames%20filled%20with%20donated%20books%2C%20small%20reading%20corner%20in%20a%20neighborhood%20alley%2C%20warm%20sunlight%2C%20documentary%20lifestyle%20photography%2C%20warm%20earthy%20tones%2C%20inviting%20tidy%20composition&width=1200&height=800&seq=gossip-community-library-09&orientation=landscape",
    coverAlt: "社区小巷里的旧物改造书架",
    tags: ["邻里", "阅读", "温暖日常"],
    heat: 38940,
    likes: 1298,
    favorites: 496,
    replyCount: 76,
    pinned: false,
    essence: false,
    content: [
      "社区里有个废弃的旧公交站牌，风吹日晒了好几年，居委会商量着拆掉。后来有人提议，不如改成书架，放在小广场边上。",
      "改造花了不到一周。铁架上刷了一层清漆，横档拿来放书。第一天摆上去的，是居委会仓促凑的二十来本旧杂志。",
      "第二天去看，架子上多了三十多本书，还有几张手写便签夹在书页里：「这本我看了三遍，第三遍最好哭。」「借走不用还，看完传给下一个人。」",
      "最旺的是傍晚。带孩子的家长会停下来翻两页，放学的孩子蹲在地上看漫画，有老人专门来看报纸。",
      "一个星期后，架子上的书换了一批又一批。我重新贴上标语的时候，写的是：「请随意，别客气。」因为这里的东西，本来就是大家自己的。",
    ],
    replies: [
      {
        id: "r-1016-1",
        author: "巷口修鞋摊",
        role: "围观群众",
        time: "4 天前",
        content: "那几张便签是我女儿写的，她说想把喜欢的话留给不认识的人，我说这挺好。",
        likes: 862,
        essence: true,
      },
      {
        id: "r-1016-2",
        author: "图书漂流员",
        role: "金句制造机",
        time: "4 天前",
        content: "「借走不用还，看完传给下一个人」，这句话应该刻在书架上。",
        likes: 604,
        essence: true,
      },
    ],
  },
];

export const hotTags: string[] = [
  "今日热帖",
  "神回复",
  "职场",
  "邻里",
  "校园",
  "生活灵感",
  "网络热梗",
  "温暖日常",
];